import React, { useState, useEffect } from "react";

import PersonalPhoto from "../components/PersonalPhoto.js";
import CardAboutMe from "../components/CardAboutMe.js";
import LaborStatistics from "../components/LaborStatistics.js";
import CardCertifications from "../components/CardCertifications.js";
import Universities from "../components/Universities.js";
import Jobs from "../components/Jobs.js";
import Proyects from "../components/Proyects.js";
import Statistics from "../components/Statistics.js";
import ContactInformation from "./ContactInformation.js";

import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

import Box from "@mui/material/Box";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";


import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SchoolIcon from "@mui/icons-material/School";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import SendIcon from "@mui/icons-material/Send";

function Mobile() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  //detecta si la pantalla esta en horizontal o vertical
  useEffect(() => {
    const mediaQuery = window.matchMedia("(orientation: portrait)");
    const handler = () => setIsPortrait(mediaQuery.matches);

    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  //descarga el cv
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = '/media/Curriculum.pdf'; // URL del documento
    link.download = "cv_jesus_gomez.pdf"; // Nombre con el que se guardará
    link.target = "_blank"; // Opcional: abre en otra pestaña
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const actions = [
    {
      icon: <SchoolIcon onClick={() => setActiveStep(2)} />,
      name: "Academico",
    },
    {
      icon: <BusinessCenterIcon onClick={() => setActiveStep(3)} />,
      name: "Laboral",
    },
    {
      icon: <IntegrationInstructionsIcon onClick={() => setActiveStep(5)} />,
      name: "Proyectos",
    },
    { 
      icon: <SendIcon onClick={() => setActiveStep(6)} />, 
      name: "Contactame" 
    },
    { 
      icon: <CloudDownloadIcon onClick={() => handleDownload()} />, 
      name: "Mi CV" 
    },
  ];

  const horizontalDisplay = () => {
    return (
      <video width="100%" loop autoPlay muted controls>
        <source src="/video/gira.mp4" type="video/mp4" />
        Gira tu celular por favor
      </video>
    );
  };

  const verticalDisplay = () => {
    return (
      <div className="flex flex-col h-screen overflow-hidden">
        {/* Foto - nombre */}
        <PersonalPhoto isMobile={true} setActiveStep={setActiveStep}/>

        {/* Contenido principal */}
        <div className="flex flex-col h-full p-4 bg-negro_alt shadow-lg overflow-y-auto custom-scrollbar">
          {activeStep == 0 && <Statistics isMobile={true}/>}
          <div className="p-5">
            {activeStep == 1 && (
              <>
                <CardAboutMe isMobile={true} />
                <LaborStatistics isMobile={true} />
              </>
            )}
            {activeStep == 2 && <Universities />}
            {activeStep == 3 && <Jobs />}
            {activeStep == 4 && <CardCertifications isMobile={true} />}
            {activeStep == 5 && <Proyects isMobile={true} />}
            {activeStep == 6 && <ContactInformation isMobile={true} />}
          </div>
        </div>

        {/* Pie fijo sin scroll */}
        <div className="w-full bg-gris fixed bottom-0 left-0 z-10">
          {/* Atajos rápidos */}
          <Box sx={{ transform: "translateZ(0px)", flexGrow: 1 }}>
            <SpeedDial
              ariaLabel="SpeedDial basic example"
              sx={{ position: "absolute", bottom: 16, right: 16 }}
              FabProps={{
                sx: {
                  bgcolor: "#ffc107",
                  "&:hover": {
                    bgcolor: "#ffc107",
                  },
                },
              }}
              icon={<SpeedDialIcon className="text-negro" />}
            >
              {actions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                />
              ))}
            </SpeedDial>
          </Box>

          {/* Navigation */}
          <MobileStepper
            variant="dots"
            steps={7}
            position="static"
            activeStep={activeStep}
            sx={{
              width: "100%",
              flexGrow: 1,
              backgroundColor: "#2d2d3a",
              ".MuiMobileStepper-dot": {
                backgroundColor: "#1e1e28",
              },
              ".MuiMobileStepper-dotActive": {
                backgroundColor: "#ffc107",
              },
            }}
            nextButton={
              <Button
                size="small"
                onClick={handleNext}
                disabled={activeStep === 6}
                sx={{
                  color: activeStep === 6 ? "#1e1e28" : "#ffc107",
                }}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
                ) : (
                  <KeyboardArrowRight />
                )}
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={activeStep === 0}
                sx={{
                  color: activeStep === 0 ? "#1e1e28" : "#ffc107",
                }}
              >
                {theme.direction === "rtl" ? (
                  <KeyboardArrowRight />
                ) : (
                  <KeyboardArrowLeft />
                )}
              </Button>
            }
          />
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-screen bg-negro p-0 relative">
      {isPortrait ? verticalDisplay() : horizontalDisplay()}
    </div>
  );
}

export default Mobile;
